function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import '../scss/main.scss'; // IF we're in an iframe...

var isEmbedded = window.location !== window.parent.location; // You can write code specific to embeds like this...

if (isEmbedded) {
  try {
    window.childFrame.sendHeight();
  } catch (err) {
    console.log('pym not found.');
  }
}

import AnimationMaker from './AnimationMaker.js';
import lottieTemplate from './lottie_template.ejs';
import marked from 'marked';
var graphic_url_path = window.GRAPHIC_URL_PATH || ''; //IMPORT the main HTML

import article from './article.ejs';
import text from '../../locales/en/text.json';
text.blocks.forEach(function (block) {
  var html = article({
    block: block,
    parseMarkdown: marked,
    graphic_url_path: graphic_url_path,
    text: text
  });
  var elems = document.querySelectorAll(block.Element);
  [].forEach.call(elems, function (el, i) {
    el.innerHTML = html;
  });
});
var lottieObjects = {};
var targets = document.querySelectorAll('.lottie-target');
[].forEach.call(targets, function (el, i) {
  var id = el.getAttribute('id').split('lottie-')[1];

  var blurbs = _toConsumableArray(el.querySelectorAll('.blurb')).map(function (blrb) {
    return {
      text: blrb.innerHTML,
      seconds: blrb.getAttribute('seconds')
    };
  });

  el.querySelectorAll('.blurb').forEach(function (blrb) {
    return blrb.remove();
  });
  el.innerHTML += lottieTemplate({
    id: id,
    blurbs: blurbs
  });
  lottieObjects[id] = new AnimationMaker({
    id: id,
    graphic_url_path: graphic_url_path,
    blurbs: blurbs,
    playbackConst: 50,
    widthRatio: 1.78,
    fullFrame: true,
    includeSmall: true,
    smallWidthRatio: 1
  });
});